const designGearSections = [...document.querySelectorAll('.js-designGear')];

if (designGearSections.length > 0) {
  designGearSections.forEach(function applyGearAnimations(designGearSection) {
    const bigGear = designGearSection.querySelector('.js-bigGear');
    const smallGear = designGearSection.querySelector('.js-smallGear');
    const gearListLinks = [...designGearSection.querySelectorAll('.js-gearListLink')];
    const descriptionItems = [
      ...designGearSection.querySelectorAll('.js-descriptionItem'),
    ];

    gearListLinks.forEach(gearListLink => {
      gearListLink.addEventListener('click', e => {
        e.preventDefault();

        const angle = gearListLink.dataset.angle * 1;
        const descriptionValue = gearListLink.dataset.gearLink;
        const descriptionItem = designGearSection.querySelector(
          `.js-descriptionItem[data-description="${descriptionValue}"]`
        );

        const activeLinks = [
          ...designGearSection.querySelectorAll(
            `.js-gearListLink[data-gear-link="${descriptionValue}"]`
          ),
        ];

        gearListLinks.forEach(listLink => listLink.classList.remove('-active'));

        activeLinks.forEach(activeLink => activeLink.classList.add('-active'));

        descriptionItems.forEach(uniqueDescriptionItem => {
          uniqueDescriptionItem.classList.remove('-displayed');
        });

        descriptionItem.classList.add('-displayed');

        bigGear.style.transform = `rotate(-${angle}deg)`;
        smallGear.style.transform = `rotate(${angle}deg)`;
      });
    });
  });
}
